import { useRouter } from "next/router";
import RoundButton from "../../../../common/button/RoundButton";
import { makeStyles, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from "react";
import BasicModal from "../../../../basicModal";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
const useStyles = makeStyles((theme) => ({

    cancel: {
      width: "65%",
      borderRadius: "30px",
      backgroundColor: "#009693",
      color: "#FFFFFF",
      "&:hover": { backgroundColor: "#009693", color: "#FFFFFF" },
    },

  }));
  

const Support = ({ data }) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const classes=useStyles()
  const router = useRouter();
  return (
    <>
    <div style={{display:"flex",justifyContent:isMobile?"center":"flex-end",marginTop:"30px" }}>
      <div style={{display:"flex",justifyContent:isMobile?"":"space-between",alignItems:"center",width:isMobile?"100%":"100%" ,flexDirection:isMobile?"column":"row" }}>
      <div style={{width: '300px', marginLeft: "auto", marginRight: "auto",transform: isMobile ? 'translateX(-20%)' : 'translateX(-28%)'}}>
        <RoundButton
          onClick={() =>
            router.push(`/payment-methods/${data?.code}/${data?.slug}`)
          }
          customClassName={classes.cancel}
        >
          صفحه حمایت
        </RoundButton>
        </div>        <InfoOutlinedIcon
        style={{
            color:"#004CFF",
            width:"40px",
            height:"40px",
            cursor:"pointer",
            marginTop:isMobile?"10px":""
        }}
        onClick={() => setOpen(true)}
        />
      </div>
      </div>
      <BasicModal open={open} setOpen={setOpen}>
        <div
        style={{display:"flex",justifyContent:"flex-end"}}
        
        >
        <CloseOutlinedIcon
        style={{cursor:"pointer"}}
        onClick={() => setOpen(false)}
        />
        </div>
        <Typography variant="h6" style={{marginTop: '10px'}}>
        ما ضمن اعتبارسنجی حقوقی سازمان‌مردم‌نهاد، بستری برای نمایش اطلاعات و تبادل ارزش فراهم نموده‌ایم. اطلاعات ارائه شده از سوی سازمان مردم‌نهاد ثبت شده است. لذا مسئولیتی در قبال محتوای منتشر شده از سوی آن سازمان نداریم.
        </Typography>
      </BasicModal>

    </>
  );
};

export default Support;
